<template>
  <div class="wangEditor">
    <a-spin v-show="loading" class="loading"></a-spin>
    <div ref="wang" style="white-space: pre-wrap;"></div>
  </div>
</template>
<style lang="less" scoped>
/deep/video {
  width: 200px;
  height: 100px;
}

.loading {
  position: absolute;
  left: 40%;
  top: 4%;
  z-index: 99;
}

/deep/.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.right {
  display: none;
}
</style>
<script>
import wangeditor from 'wangeditor';
import axios from 'axios';
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    option: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      temp: '',
      editor: null,
      isChange: false,
      access_token: this.$store.state.access_token || localStorage.getItem('access_token'),
    };
  },
  watch: {
    value(m) {
      if (!this.isChange) {
        this.editor.$textElem.html(m);
      }
      this.isChange = false;
    },
  },
  mounted() {
    this.editor = new wangeditor(this.$refs.wang);
    // 配置菜单栏，删减菜单，调整顺序
    this.editor.config.menus = [
      'bold', // 粗体
      'fontSize', // 字号
      'fontName', // 字体
      'foreColor', // 文字颜色
      'justify', // 对齐方式
      // 'quote', // 引用
      // 'image', // 插入图片
      // 'table', // 表格
      // 'video', // 插入视频
      // 'audio',
      // 'undo', // 撤销
      // 'redo', // 重复
      'fullscreen', // 全屏
    ];
    this.editor.txt.eventHooks.changeEvents.push(() => {
      this.isChange = true;
      this.$emit('input', this.editor.$textElem.html());
    });
    this.editor.config.height = 220;
    this.editor.config.fontNames = ['黑体', '仿宋', '楷体', '宋体', '微软雅黑', 'Arial', 'Times New Roman'];
    // 上传本地图片
    this.editor.config.showLinkImg = false; // 关闭插入网络图片
    this.editor.config.uploadImgMaxSize = 2 * 1024 * 1024; // 5M
    this.editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
    this.editor.config.uploadImgMaxLength = 1; // 一次最多上传 1 个图片
    this.editor.config.customUploadImg = (resultFiles, insertImgFn) => {
      if (resultFiles.size / 1024 / 1024 > 0.5) {
        this.$message.warning('请上传500KB以下图片');
        return;
      }
      const formData = new FormData();
      formData.append('file', resultFiles[0]);
      formData.append('customDir', 'hytc_ebook_server/file');
      formData.append('access_token', this.access_token || '');
      const _this = this;
      _this.editor.initSelection();
      _this.loading = true;
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((res) => {
        if (res && res.status === 200) {
          _this.loading = false;
          insertImgFn(`${_this.$resBasePath}/${res.data.url}`);
        } else {
          _this.loading = false;
          _this.$message.error('上传失败');
        }
      });
    };
    // 上传本地视频
    this.editor.config.showLinkVideo = false; // 关闭插入网络视频
    this.editor.config.uploadVideoMaxSize = 512 * 1024 * 1024; // 512M
    this.editor.config.uploadVideoAccept = ['mp4', 'MOV'];
    this.editor.config.uploadVideoTimeout = 1000 * 60 * 5; // 上传接口等待的最大时间
    this.editor.config.customUploadVideo = (resultFiles, insertVideoFn) => {
      if (resultFiles.size / 1024 / 1024 > 100) {
        this.$message.warning('请上传100M以下视频');
        return;
      }
      this.loading = true;
      const _this = this;
      _this.editor.initSelection();
      const formData = new FormData();
      formData.append('file', resultFiles[0]);
      formData.append('customDir', 'hytc_ebook_server/file');
      formData.append('access_token', _this.access_token);

      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((res) => {
        if (res && res.status === 200) {
          _this.loading = false;
          insertVideoFn(`${_this.$resBaseVideo}/${res.data.url}`);
        } else {
          _this.loading = false;
          _this.$message.error('上传失败');
        }
      });
    };
    this.editor.config.showRecordAudio = false;
    this.editor.config.customUploadAudio = function (resultFiles, insertAudioFn) {
      if (resultFiles.size / 1024 / 1024 > 10) {
        this.$message.warning('请上传100M以下音频');
        return;
      }
      const formData = new FormData();
      formData.append('file', resultFiles[0]);
      formData.append('customDir', 'hytc_ebook_server/file');
      formData.append('access_token', this.access_token);
      const _this = this;
      _this.editor.initSelection();
      _this.loading = true;
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((res) => {
        if (res && res.status === 200) {
          this.loading = false;
          insertAudioFn(`${_this.$resBaseVideo}/${res.data.url}?isPlay=1`);
        } else {
          _this.loading = false;
          _this.$message.error('上传失败');
        }
      });
    };
    this.editor.config.focus = false;
    this.editor.create();
    if (this.value.length) {
      this.editor.txt.html(this.value);
    }
  },
  // beforeDestroy(){
  //   if(this.editor){
  //     this.editor.destory()
  //   }
  // }
};
</script>
